// Provisional — not confirmed commercial terms.
export const SHIPPING_COST = 0;

// Fallback only: the shop API returns the product's real currency.
export const DEFAULT_CURRENCY = 'EUR';

export const MIN_QUANTITY = 1;

export const MAX_QUANTITY = 99;

export const VAT_LABEL = 'VAT';

export const VAT_NOTE = 'Calculated at checkout';
